import { render, staticRenderFns } from "./PortalParentFolderPermissions.vue?vue&type=template&id=a1dd84f8&scoped=true&"
import script from "./PortalParentFolderPermissions.vue?vue&type=script&lang=js&"
export * from "./PortalParentFolderPermissions.vue?vue&type=script&lang=js&"
import style0 from "./PortalParentFolderPermissions.vue?vue&type=style&index=0&id=a1dd84f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dd84f8",
  null
  
)

export default component.exports